import React, { createContext, useContext, useState, useEffect } from "react";

import i18n from "../i18n";

const LanguageContext = createContext();

// Utilities to interact with localStorage safely
const loadFromStorage = (key, fallback) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : fallback;
  } catch {
    return fallback;
  }
};

const saveToStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore storage write errors (e.g. private mode)
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => loadFromStorage("language", i18n.language));

  useEffect(() => {
    const handleLanguageChange = () => {
      setLanguage(i18n.language);
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  useEffect(() => {
    if (language) {
      saveToStorage("language", language.split("-")[0]);
    }
  }, [language]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
